import React from "react";
import { useTranslation } from "react-i18next";
import { useUser } from "../empreenderUI/UserContext";

interface CartaoSemPlanoProps {
  aoContinuarComIa: () => void;
}

// Exibido no lugar do WhatsApp quando a regra de plano estiver ligada e o cliente não tiver plano.
const CartaoSemPlano: React.FC<CartaoSemPlanoProps> = ({ aoContinuarComIa }) => {
  const { t } = useTranslation();
  const linkPagamento = useUser()?.user?.current_store?.link_abrir_modal_pagamento;

  return (
    <div className="cartao-suporte">
      <p className="cartao-suporte-titulo">{t("sem_plano_titulo")}</p>
      <p className="cartao-suporte-texto">{t("sem_plano_texto")}</p>
      <div className="cartao-suporte-acoes">
        <button className="botao-secundario" onClick={aoContinuarComIa}>
          {t("continuar_com_ia")}
        </button>
        {linkPagamento && (
          <a className="botao-primario" href={linkPagamento} target="_blank" rel="noopener noreferrer">
            {t("ver_planos")}
          </a>
        )}
      </div>
    </div>
  );
};

export default CartaoSemPlano;
